module.exports = __webpack_public_path__ + "static/uber_395x510-df74463fae041a5e900dc8eeb1a1d51a.png";